import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "img-loader-11", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 11 11", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("defs", null,
        React.createElement("linearGradient", { id: "svg-ef719feb__a", x1: "0%", x2: "56.419%", y1: "42.818%", y2: "114.195%" },
            React.createElement("stop", { offset: "0%", stopColor: "currentColor" }),
            React.createElement("stop", { offset: "100%", stopColor: "currentColor", stopOpacity: 0 }))),
    React.createElement("path", { fill: "url(#svg-ef719feb__a)", d: "M10 5.5A4.5 4.5 0 0 1 5.5 10a.75.75 0 0 1 0-1.5 3 3 0 1 0-3-3 .75.75 0 0 1-1.5 0 4.5 4.5 0 0 1 9 0Z", transform: "matrix(-1 0 0 1 11 0)" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
